<template>
  <el-dialog
    title="Редактирование цен дня"
    :visible="visible"
    width="50%"
    custom-class="day-add-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="responseData"
      :rules="dayAddRules"
      @submit.native.prevent
    >
      <el-row v-if="canAction('shipping_bids_edit')" :gutter="40">
        <template v-if="type !== 'harvest'">
          <el-col :span="12">
            <el-form-item prop="price_from_storage_bidder">
              <p>Цена перевозки, руб/кг</p>
              <el-input-number
                v-model="responseData.price_from_storage_bidder"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену перевозки"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="isAdminOrCeoRole"
              prop="price_from_storage_driver"
            >
              <p>Цена перевозки для водителя, руб/кг</p>
              <el-input-number
                v-model="responseData.price_from_storage_driver"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену перевозки для водителя"
              />
            </el-form-item>
          </el-col>
        </template>
        <template v-if="type !== 'delivery'">
          <el-col :span="12">
            <el-form-item prop="price_from_field_bidder">
              <p>Цена уборки, руб/кг</p>
              <el-input-number
                v-model="responseData.price_from_field_bidder"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену уборки"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="isAdminOrCeoRole"
              prop="price_from_field_driver"
            >
              <p>Цена уборки для водителя, руб/кг</p>
              <el-input-number
                v-model="responseData.price_from_field_driver"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену уборки для водителя"
              />
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        :disabled="loading"
        :loading="loading"
        type="primary"
        @click="updateLoadDay"
      >
        Сохранить
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { dayAddRules } from '@/views/Home/Shipping/Item/constants'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'EditPricesModal',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      responseData: {
        price_from_storage_bidder: undefined,
        price_from_storage_driver: undefined,
        price_from_field_bidder: undefined,
        price_from_field_driver: undefined,
      },
      dayAddRules,
      loading: false,
    }
  },
  methods: {
    beforeOpen() {
      for (let key in this.responseData) {
        if (!Object.prototype.hasOwnProperty.call(this.responseData, key)) {
          continue
        }
        this.responseData[key] = this.response[key]
      }
    },
    updateLoadDay() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          Responses.updateResponse(this.response.id, this.responseData)
            .then(() => {
              this.$emit('update')
              this.beforeClose()
            })
            .catch(e => this.errHandler(e))
            .finally(() => (this.loading = false))
        }
      })
    },
    beforeClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.day-add-modal
  .el-form-item__content
    line-height: 1
  .el-input-number, .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
</style>
